import { AccordionDetails, Typography, styled } from '@mui/material';
import MuiAccordion, { AccordionProps } from '@mui/material/Accordion';
import MuiAccordionSummary, {
  AccordionSummaryProps,
} from '@mui/material/AccordionSummary';
import { Icon } from '../../icon/icon';

const Accordion = styled((props: AccordionProps) => (
  <MuiAccordion
    {...props}
    disableGutters
    TransitionProps={{ unmountOnExit: true, mountOnEnter: true }}
  />
))(() => ({}));

const AccordionSummary = styled((props: AccordionSummaryProps) => (
  <MuiAccordionSummary
    expandIcon={
      <Icon
        icon="ChevronDown"
        color="inherit"
        fontSize="small"
        styleType="regular"
      />
    }
    {...props}
  />
))(() => ({
  '& .MuiAccordionSummary-content.Mui-expanded': {
    fontWeight: 'bold',
  },
}));

export const InsuranceFaq = () => (
  <>
    <Accordion sx={{ mt: 2 }}>
      <AccordionSummary>
        Can I get an estimate of my visit cost?
      </AccordionSummary>
      <AccordionDetails>
        <Typography>
          Yes. Your visit cost depends on the details of your coverage. For
          some, it's just a copay. If you have an unmet deductible, it could be
          more.
        </Typography>
        <Typography sx={{ my: 3 }}>
          The best way to get a detailed estimate is to contact your insurance
          company directly.
        </Typography>
        <Typography>
          Call the number on your insurance card and ask about your plan's
          coverage for outpatient psychiatric services.
        </Typography>
      </AccordionDetails>
    </Accordion>
    <Accordion>
      <AccordionSummary>Do I have to go through insurance?</AccordionSummary>
      <AccordionDetails>
        <Typography sx={{ mb: 3 }}>
          Right now, we only see patients whose insurance we accept, and we
          don't have a self-pay option.
        </Typography>
        <Typography>
          If don't have insurance or a plan we accept today, sites like
          Zocdoc.com and Psychologytoday.com can help you find care.
        </Typography>
      </AccordionDetails>
    </Accordion>
    <Accordion>
      <AccordionSummary>Do you take Medicaid?</AccordionSummary>
      <AccordionDetails>
        <Typography>
          We don't take Medicaid at this time. For help finding clinicians who
          do, we recommend using Zocdoc.com, PsychologyToday.com, or your
          state's Medicaid website. If you have a primary care doctor, they may
          be able to provide a referral.
        </Typography>
      </AccordionDetails>
    </Accordion>
    <Accordion>
      <AccordionSummary>What if I have a deductible?</AccordionSummary>
      <AccordionDetails>
        <Typography>
          Some insurance plans have a deductible, an amount you have to pay out
          of pocket before your insurance starts paying.
        </Typography>
        <Typography sx={{ my: 3 }}>
          If you haven’t reached your deductible, your insurance may not cover
          the costs of your visit until you do.
        </Typography>
        <Typography>
          The best way to find out how much your insurance will cover is to call
          your insurer directly. You can find their number on your insurance
          card.
        </Typography>
      </AccordionDetails>
    </Accordion>
    <Accordion>
      <AccordionSummary>Do you bill my insurance directly?</AccordionSummary>
      <AccordionDetails>
        <Typography>
          We do bill your insurance directly, and we won’t send you a statement
          until after they respond.
        </Typography>
        <Typography sx={{ my: 3 }}>
          How long this takes depends on your insurer. Some patients don’t
          receive a bill for a few weeks.
        </Typography>
        <Typography>
          If you need to know how much you’ll owe for your visits ahead of time,
          we recommend contacting your insurer directly to get the most accurate
          estimate.
        </Typography>
      </AccordionDetails>
    </Accordion>
    <Accordion sx={{ mb: 2 }}>
      <AccordionSummary>Do you offer payment plans?</AccordionSummary>
      <AccordionDetails>
        <Typography sx={{ mb: 3 }}>
          We do. For balances over $250, we offer the option to pay over time,
          on a schedule you choose.
        </Typography>
        <Typography>
          After you receive your first statement, you can enroll in a payment
          plan online. Choose either a monthly or biweekly plan. The minimum
          payment amount is $50 and the maximum repayment period is 6 months.
        </Typography>
      </AccordionDetails>
    </Accordion>
  </>
);
